import { toFloatingTimeString } from './appointmentTimeUtils';
import { captureClinicalNow, resolveClinicalTime, clinicalWallTime, clinicalOffset, offsetSuffix } from './clinicalTime';

// Labor records store the UTC date and UTC time separately. Birth-event and
// postpartum fields instead hold charted clock times; do not use this for them.
export function getLaborRecordChartDateTime(record, timeZoneId) {
  const date = String(record?.date ?? record?.Date ?? '').split(/[T ]/)[0];
  const time = String(record?.time ?? record?.Time ?? '');
  if (!date || !time) return '';
  const instant = new Date(`${date}T${time}Z`);
  if (Number.isNaN(instant.getTime())) return '';
  const info = record?.clinicalTimeMetadata?.recordedAt ?? record?.ClinicalTimeMetadata?.recordedAt;
  const occurrence = info && `${info.localDateTime}${offsetSuffix(info.utcOffsetMinutes)}`;
  if (occurrence && Date.parse(occurrence) === instant.getTime()) return info.localDateTime;
  return toFloatingTimeString(instant.toISOString(), timeZoneId);
}

export function getLaborRecordChartParts(record, timeZoneId) {
  const value = getLaborRecordChartDateTime(record, timeZoneId);
  return { date: value.slice(0, 10), time: value.slice(11, 16) };
}

export function getLaborRecordOccurrence(record, timeZoneId) {
  const date = String(record?.date ?? record?.Date ?? '').split(/[T ]/)[0];
  const time = String(record?.time ?? record?.Time ?? '');
  const instant = new Date(`${date}T${time}Z`);
  if (Number.isNaN(instant.getTime())) return null;
  const info = record?.clinicalTimeMetadata?.recordedAt ?? record?.ClinicalTimeMetadata?.recordedAt;
  const occurrence = info && `${info.localDateTime}${offsetSuffix(info.utcOffsetMinutes)}`;
  return occurrence && Date.parse(occurrence) === instant.getTime() ? occurrence : captureClinicalNow(timeZoneId || 'UTC', instant);
}

export function resolveLaborRecordTime(date, time, timeZoneId, captured) {
  const wall = `${date}T${time}`;
  // An unrelated edit must not discard either the occurrence or saved seconds.
  if (captured && clinicalOffset(captured) !== null && clinicalWallTime(captured)?.startsWith(wall))
    return { value: captured, candidates: [captured] };
  return resolveClinicalTime(wall, timeZoneId);
}

export function laborRecordChartTimeToUtc(date, time, timeZoneId, captured) {
  const resolved = resolveLaborRecordTime(date, time, timeZoneId || 'UTC', captured);
  if (!resolved.value) throw new Error(resolved.error);
  return new Date(resolved.value).toISOString();
}
